import { render, staticRenderFns } from "./InputPrompt.vue?vue&type=template&id=6d9538ba&"
import script from "./InputPrompt.vue?vue&type=script&lang=js&"
export * from "./InputPrompt.vue?vue&type=script&lang=js&"
import style0 from "./InputPrompt.vue?vue&type=style&index=0&id=6d9538ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports